import { render, staticRenderFns } from "./current.vue?vue&type=template&id=4882eb6c&scoped=true&"
import script from "./current.vue?vue&type=script&lang=js&"
export * from "./current.vue?vue&type=script&lang=js&"
import style0 from "./current.vue?vue&type=style&index=0&id=4882eb6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882eb6c",
  null
  
)

export default component.exports